export default (theme) => ({
  container: {
    margin: "auto",
    maxWidth: 1200,
  },
  h4: {
    fontWeight: 700,
  },
});
